import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/Header.css";

function Header() {
  const [darkToggle, setDarkToggle] = useState(false);
  const navigate = useNavigate()

  const CreateAccount = () => {
    navigate("/signup");
  };

  const handleTheme = (e) => {
    localStorage.setItem("theme", e);
  };
  return (
    <div className="container-fluid headerClass">
      <div className="sections">
        <div>
          <span className="pe-md-4 pe-3 dd">Jolly</span>
        </div>
        <div className="searchBar">
          <img src="search (1).png" alt="search" />
          <input type="search" placeholder="Search Collections and Creators" />
        </div>
        <div className="accountDetails d-md-flex d-none">
          <div className="">
            <label className="toggleDarkBtn toggles hightBar">
              <input
                type="checkbox"
                // checked={localStorage.getItem("theme") === "true"}
                onChange={(e) => {
                  setDarkToggle(!darkToggle);
                  handleTheme(e.target.checked);
                }}
              />
              <span className="slideBtnTg round d-flex justify-content-around align-items-center">
                <div>
                  <img
                    src="iphone-night-shift 1.svg"
                    alt="moon"
                    className="position-relative me-1"
                  />
                </div>
                <div>
                  {/* <HiMoon/> */}

                  <img
                    src="Group 33550.svg"
                    alt="moon"
                    className="position-relative"
                  />
                  {/* <img src="Group 33550.png" alt="moon" className="position-relative"/> */}
                </div>
              </span>
            </label>
          </div>

          <div className="d-flex gapWallet  ">
            <a className="bttn" href="#">
              Connect Wallet
            </a>
            <button className="account" onClick={() => CreateAccount()}>
              Create account
            </button>
          </div>
        </div>
        <div className="d-md-none d-block">
          <div className="dropdown">
            <button
              className="dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            ></button>
            <ul
              className="dropdown-menu dropdownSection"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <div className="dropdown-item">
                  <label className="toggleDarkBtn toggles hightBar">
                    <input
                      type="checkbox"
                      checked={localStorage.getItem("theme") === "true"}
                      onChange={(e) => {
                        setDarkToggle(!darkToggle);
                        handleTheme(e.target.checked);
                      }}
                    />
                    <span className="slideBtnTg round d-flex justify-content-around align-items-center">
                      <div>
                        <img
                          src="iphone-night-shift 1.png"
                          alt="moon"
                          className="position-relative me-1"
                        />
                      </div>
                      <div>
                        {/* <HiMoon/> */}

                        <img
                          src="moon 1.svg"
                          alt="moon"
                          className="position-relative"
                        />
                        {/* <img src="Group 33550.png" alt="moon" className="position-relative"/> */}
                      </div>
                    </span>
                  </label>
                </div>
              </li>
              <li>
                <a className="bttn dropdown-item " href="#">
                  Connect Wallet
                </a>
              </li>
              <li>
                <button className="account dropdown-item  ">
                  Create account
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
